/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "api19a88d9c",
            "endpoint": "https://v7uaqzrlgk.execute-api.us-east-2.amazonaws.com/prod",
            "region": "us-east-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://xczqyawsr5e53jpjchgpqdnw6e.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-2nt7rkbzajbsnptcqzp66usq7a",
    "aws_cognito_identity_pool_id": "us-east-2:0db25b3b-2da3-459e-b0ba-12f94b9d4959",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_TAAg2NizV",
    "aws_user_pools_web_client_id": "6oqoca82abm98hbri982b01mcf",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "idenciaamplify-20240626164435-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "us-east-2",
    "aws_content_delivery_url": "https://d2zspzt55bkdw6.cloudfront.net",
    "aws_user_files_s3_bucket": "idenciaproductioncontentbucket201243-prod",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
